import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Autocomplete, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useRouter } from 'next/router';
import { GetHelpSearchArticleFaq, GetHelpSellerSearchArticleFaq } from '@/api/help';
import { IHelpFaqArticle } from '@/interfaces/help';
import MenuCategoryList from './MenuCategoryList';
import he from 'he';

type Props = {
    form: string;
    faqs :any
   
};

const HelpInputSearch: React.FC<Props> = ({ form, faqs}) => {
 
    const [value, setValue] = useState<string>("");
    const [options, setOptions] = useState<IHelpFaqArticle[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedSlug, setSelectedSlug] = useState<string>("");
    const router = useRouter();
  
  

    const handleSearch = async (keyword: string) => {
        setLoading(true);
        try {
            if (form == "SHOP") {
                const result = await GetHelpSearchArticleFaq(keyword);
                setOptions(result.data);
            } else if (form == "SELLER") {
                const result = await GetHelpSellerSearchArticleFaq(keyword);
                setOptions(result.data);
            }
        } catch (error) {
            console.error('Search error:', error);
            setOptions([]);
        } finally {
            setLoading(false); 
        }
    };

   

    const handleSearchClick = () => {
        const faqsData = faqs?.find((option:any) => option.slug === selectedSlug);
       
        if (faqsData) {
            const categorySlug = faqsData.category_slug;
            const faqSlug = faqsData.slug;
            router.push(`/help/shop/${categorySlug}/${faqSlug}`);
        }
    };

   

    const handleEnterSearch = (inputValue: any, event: any) => {
        if (event.key === 'Enter') {
            if (selectedSlug) {
               
                handleSearchClick(inputValue);
            } else {
               
                router.push(`/help/searchHelp?keyword=${encodeURIComponent(inputValue)}`);
            }
        }
    };
    // const handleEnterSearch = (value: any, event: any) => {
    //     if (event.key === 'Enter') {
    //         handleSearchClick();
           
    //     }
    // };


   
    return (
        <Box
            sx={{
                backgroundColor: "#DB5A00",
                p: { xs: 3, md: 5 },
                borderRadius: "12px",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                mt:"20px"
            }}
        >
            <Typography
                className="txt-bold"
                sx={{
                    textAlign: "center",
                    fontSize: { xs: "28px", md: "36px" },
                    color: "#ffffff",
                    mb: 3,
                }}
            >
                สวัสดี มีอะไรให้ช่วยหรือไม่
            </Typography>
            <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={10} md={8}>
                  
                    {/* <Autocomplete
                        inputValue={value}
                        onInputChange={(event, newInputValue) => {
                            setValue(newInputValue);
                            handleSearch(newInputValue);
                        }}
                        options={options}
                        loading={loading}
                        getOptionLabel={(option:any) => {
                            if (typeof option === 'string') {
                                return option;
                            } else {
                                return  he.decode(option.title);
                               
                            }
                        }}
                        onChange={(event, newValue) => {
                            if (newValue && typeof newValue !== 'string') {
                                setSelectedSlug(newValue.slug);
                            }
                        }}
                        freeSolo
                        renderInput={(params) => (
                            <TextField

                                onChange={handleSearchClick}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                    
                                        handleSearchClick();
                                    }
                                    handleEnterSearch(params.inputProps.value, e);
                                }}
                                {...params}
                                label="ค้นหา"
                                sx={{
                                    backgroundColor: "#ffffff",
                                    borderRadius: "8px",
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "#DB5A00",
                                            borderRadius:"8px"
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#DB5A00",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#ffff",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: "#DB5A00",
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "#ffff",
                                        background: "#DB5A00",
                                        px: 1,
                                        borderRadius: "8px",
                                    },
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {params.InputProps.endAdornment}
                                            <FontAwesomeIcon
                                                icon={faMagnifyingGlass}
                                                onClick={handleSearchClick}
                                                style={{
                                                    cursor: 'pointer',
                                                    color: '#DB5A00',
                                                    marginLeft: '8px',
                                                    padding: 10
                                                }}
                                            />
                                        </>
                                    ),
                                }}
                            />
                        )}
                    /> */}


                    <Autocomplete
                        inputValue={value}
                        onInputChange={(event, newInputValue) => {
                            setValue(newInputValue);
                            handleSearch(newInputValue);
                        }}
                        options={options}
                        loading={loading}
                        getOptionLabel={(option: any) => {
                            if (typeof option === 'string') {
                                return option;
                            } else {
                                return he.decode(option.title);
                            }
                        }}
                        onChange={(event, newValue) => {
                            if (newValue && typeof newValue !== 'string') {
                                setSelectedSlug(newValue.slug);
                            }
                        }}
                        freeSolo
                        renderInput={(params) => (
                            <TextField
                                onChange={handleSearchClick}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSearchClick(params.inputProps.value);
                                    }
                                    handleEnterSearch(params.inputProps.value, e);
                                }}
                                {...params}
                                label="ค้นหา"
                                sx={{
                                    backgroundColor: "#ffffff",
                                    borderRadius: "8px",
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "#DB5A00",
                                            borderRadius: "8px"
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#DB5A00",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#ffff",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: "#DB5A00",
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "#ffff",
                                        background: "#DB5A00",
                                        px: 1,
                                        borderRadius: "8px",
                                    },
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {params.InputProps.endAdornment}
                                            <FontAwesomeIcon
                                                icon={faMagnifyingGlass}
                                                onClick={() => handleSearchClick(params.inputProps.value)}
                                                style={{
                                                    cursor: 'pointer',
                                                    color: '#DB5A00',
                                                    marginLeft: '8px',
                                                    padding: 10,
                                                }}
                                            />
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />

                </Grid>
            </Grid>

           
        </Box>
    );
};

export default HelpInputSearch;
